(() => {
  const setupPearlForm = (root) => {
    if (root.dataset.elysianReady === 'true') return;
    root.dataset.elysianReady = 'true';

    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const sizeGroup = root.querySelector('.is-t4s-name__size');
    const styleGroup = root.querySelector('.is-t4s-name__style');
    const mainButton = root.querySelector('[data-atc-form]');
    const sticky = root.querySelector('[data-elysian-sticky-cart]');
    const stickyPrice = sticky?.querySelector('[data-elysian-sticky-price]');
    const stickyButton = sticky?.querySelector('[data-elysian-sticky-add]');

    if (!form || !sizeGroup || !styleGroup) return;

    const selected = (group) => group.querySelector('[data-swatch-item].is--selected');
    const isUnstitched = (value) => value === 'Unstitched';
    const variantSelect = form.querySelector('select[name="id"]');

    const variantIdFor = (sizeValue, styleValue) => {
      if (!variantSelect) return null;
      const option = Array.from(variantSelect.options).find((candidate) => {
        const values = candidate.textContent.trim().split(/\s+\/\s+/);
        return values[1] === sizeValue && values.slice(2).join(' / ') === styleValue;
      });
      return option?.value || null;
    };

    const openVariant = (event, sizeValue, styleValue) => {
      const variantId = variantIdFor(sizeValue, styleValue);
      if (!variantId || variantSelect?.value === variantId) return false;

      event.preventDefault();
      event.stopImmediatePropagation();
      variantSelect.value = variantId;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
      return true;
    };

    const sync = () => {
      const selectedStyle = selected(styleGroup);
      const unstitched = isUnstitched(selectedStyle?.dataset.value);
      sizeGroup.classList.toggle('is-hidden-for-unstitched', unstitched);
      if (stickyPrice && selectedStyle?.dataset.elysianPrice) {
        stickyPrice.textContent = selectedStyle.dataset.elysianPrice;
      }
    };

    styleGroup.addEventListener('click', (event) => {
      const target = event.target.closest('[data-swatch-item]');
      if (!target) return;

      const currentSize = selected(sizeGroup);
      const targetUnstitched = isUnstitched(target.dataset.value);
      const sizeValue = targetUnstitched || isUnstitched(currentSize?.dataset.value)
        ? (targetUnstitched ? 'Unstitched' : 'Small')
        : currentSize?.dataset.value;

      if (sizeValue && openVariant(event, sizeValue, target.dataset.value)) return;
      window.setTimeout(sync, 60);
    }, true);

    sizeGroup.addEventListener('click', (event) => {
      const target = event.target.closest('[data-swatch-item]');
      const selectedStyle = selected(styleGroup);
      const styleValue = selectedStyle?.dataset.value;

      if (!target || isUnstitched(target.dataset.value) || !styleValue || isUnstitched(styleValue)) return;
      openVariant(event, target.dataset.value, styleValue);
    }, true);

    const observer = new MutationObserver(sync);
    observer.observe(styleGroup, { attributes: true, subtree: true, attributeFilter: ['class'] });

    if (sticky && mainButton) {
      stickyButton?.addEventListener('click', () => mainButton.click());
      const visibilityObserver = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0.2 });
      visibilityObserver.observe(mainButton);
    }

    sync();
  };

  const setup = () => document.querySelectorAll('.elysian-pearl-form').forEach(setupPearlForm);
  document.addEventListener('DOMContentLoaded', setup, { once: true });
  document.addEventListener('shopify:section:load', setup);
  setup();
})();
